// The candidate summary's words (lane B7 S14, CR-007 / CR-025): the page's name, its three sections, the Recruiter's
// release, and the versioned notes' verbs. Every entry quotes his glossary (the D0 label suites discover this module,
// a lane folder of src/views, and hold it to the same rules as src/mc). Words the design system already carries (the
// summary chain, Release, Save, Edit, Concern flag, the scorecard chain, Debrief preparation, "Human decision
// remains.") are imported from it where they are drawn, never redefined here.

import { defineLabels } from "@/mc/labels";

const SUMMARY_ROW = "| Candidate summary | \"System compiles submitted scorecards, coverage, flags and summary; Recruiter reviews.\"";
const RELEASED = "\"Debrief participants see released summary.\"";
const NOTE_VERBS = "\"Users can edit, dismiss, and correct.\"";

/** The page and its sections. */
export const SUMMARY_LABELS = /* @__PURE__ */ defineLabels({
  candidateSummary: { text: "Candidate summary" },
  scorecards: { text: "Scorecards" },
  coverage: { text: "Coverage" },
  flags: { text: "Flags" },
  summary: { text: "Summary" },
  correct: { text: "Correct" },
});

/** His sentences the page states as rules. */
export const SUMMARY_RULES = /* @__PURE__ */ defineLabels({
  participantsSeeReleased: { text: "Debrief participants see released summary." },
  recruiterReviewMandatory: { text: "Make Recruiter review mandatory." },
  linksToEvidence: { text: "Summary links to source evidence." },
  sealedBeforeSubmission: { text: "No other scorecards visible before submission." },
});
